export const getRandom5Sentences = (sentences) => {
  if (sentences.length <= 5) {
    return sentences; // 5개 이하일 경우 전체 리스트 반환
  }

  const startIndex = Math.floor(Math.random() * (sentences.length - 4));
  return sentences.slice(startIndex, startIndex + 5);
};
